import { useEffect, useState } from "react";
import { formatRelativeTime } from "@/utils/format";
import "./relative-time.css";

export interface RelativeTimeProps {
  value: string;
  /** Default "оновлено". Pass "" to render bare. */
  prefix?: string;
  /** Default false. Compact form for dense single-line rows. */
  compact?: boolean;
  /** Default "caption". */
  size?: "caption" | "body";
}

/**
 * AC-19.2 freshness cue. Subdued timestamp formatter — switches from
 * relative to absolute past the 7-day threshold. Refreshes every 60s
 * while mounted so "щойно" doesn't get stale. Renders as a <time>
 * element with an ISO `datetime` attribute for screen readers.
 */
export function RelativeTime({
  value,
  prefix = "оновлено",
  compact = false,
  size = "caption",
}: RelativeTimeProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const handle = window.setInterval(() => setTick((n) => n + 1), 60_000);
    return () => window.clearInterval(handle);
  }, []);

  const formatted = formatRelativeTime(value, { compact });
  const visible = compact || prefix === "" ? formatted.text : `${prefix} ${formatted.text}`;
  const classes = ["wp-time", `wp-time--${size}`].join(" ");

  return (
    <time dateTime={value} className={classes}>
      {visible}
    </time>
  );
}
